/**
 * @generated SignedSource<<9381d7db6d65433d3f11d3b1fda652de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SaveWebPushConfigurationInput = {
  authKey: string;
  clientMutationId: string;
  endpoint: string;
  p256dhKey: string;
};
export type ActiveRepositoriesDrawerSaveWebPushConfigurationMutation$variables = {
  input: SaveWebPushConfigurationInput;
};
export type ActiveRepositoriesDrawerSaveWebPushConfigurationMutation$data = {
  readonly saveWebPushConfiguration: {
    readonly clientMutationId: string;
  };
};
export type ActiveRepositoriesDrawerSaveWebPushConfigurationMutation = {
  response: ActiveRepositoriesDrawerSaveWebPushConfigurationMutation$data;
  variables: ActiveRepositoriesDrawerSaveWebPushConfigurationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SaveWebPushConfigurationPayload",
    "kind": "LinkedField",
    "name": "saveWebPushConfiguration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ActiveRepositoriesDrawerSaveWebPushConfigurationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ActiveRepositoriesDrawerSaveWebPushConfigurationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "afd073ae453d5f900e583fc8e5062035",
    "id": null,
    "metadata": {},
    "name": "ActiveRepositoriesDrawerSaveWebPushConfigurationMutation",
    "operationKind": "mutation",
    "text": "mutation ActiveRepositoriesDrawerSaveWebPushConfigurationMutation(\n  $input: SaveWebPushConfigurationInput!\n) {\n  saveWebPushConfiguration(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "1279bc33ad4f766a3d81dc5f2aea8682";

export default node;
